import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Analisis/eliminarAnalisisSeleccion`, method: 'POST', body: {list}, token: token})
}